import { A as T } from "./Logger-51340717.mjs";
import { AccountProcessType as h, RoutePaths as N } from "@commerce-profile-webcomponents/sdk";
import { OrderType as S, updateCart as a, CartConstantsEnum as m, cartApi as P, ApiProjections as $ } from "@commerce-cart-webcomponents/sdk";
import { createCheckout as M } from "@commerce-checkout-webcomponents/ui";
import { v5 as w } from "uuid";
import { CartUpdateType as s } from "./utils/enums/enums.js";
var c = /* @__PURE__ */ ((r) => (r.PERMANENT = "localstorage", r.TEMPORARY = "sessionstorage", r.COOKIE = "cookie", r))(c || {}), L = Object.defineProperty, j = (r, t, e) => t in r ? L(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e, x = (r, t, e) => (j(r, typeof t != "symbol" ? t + "" : t, e), e);
let U = class {
  constructor(t) {
    x(this, "_options"), this._options = t;
  }
  store(t, e) {
    document.cookie = `${t}=${e}`;
  }
  retrieve(t) {
    var e;
    const n = document.cookie;
    return t && n.includes(`${t}=`) ? (e = n.split(`${t}=`)[1]) == null ? void 0 : e.split(";")[0] : "";
  }
  remove(t) {
    const e = document.cookie;
    t && e.includes(`${t}=`) && (document.cookie = `${t}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`);
  }
  clearStorage() {
  }
};
const E = U;
function R(r) {
  return btoa(encodeURIComponent(r));
}
function f(r) {
  return decodeURIComponent(window == null ? void 0 : window.atob(r));
}
function v(r) {
  return typeof r == "string" ? r : JSON.stringify(r);
}
function b(r) {
  try {
    return JSON.parse(`${r}`);
  } catch {
    return r;
  }
}
var q = Object.defineProperty, Y = (r, t, e) => t in r ? q(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e, F = (r, t, e) => (Y(r, typeof t != "symbol" ? t + "" : t, e), e);
class k {
  constructor(t) {
    F(this, "options"), this.options = t;
  }
  store(t, e) {
    var n;
    const o = (n = this.options) != null && n.encryption ? R(v(e)) : v(e);
    localStorage.setItem(t, o);
  }
  retrieve(t) {
    var e;
    const n = localStorage.getItem(t);
    return n && b((e = this.options) != null && e.encryption ? f(n) : n);
  }
  remove(t) {
    localStorage.removeItem(t);
  }
  clearStorage() {
    localStorage.clear();
  }
}
const I = k;
var J = Object.defineProperty, K = (r, t, e) => t in r ? J(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e, _ = (r, t, e) => (K(r, typeof t != "symbol" ? t + "" : t, e), e);
let V = class {
  constructor(t) {
    _(this, "options"), this.options = t;
  }
  store(t, e) {
    var n;
    const o = (n = this.options) != null && n.encryption ? R(v(e)) : v(e);
    sessionStorage.setItem(t, o);
  }
  retrieve(t) {
    var e;
    const n = sessionStorage.getItem(t);
    return n && b((e = this.options) != null && e.encryption ? f(n) : n);
  }
  remove(t) {
    sessionStorage.removeItem(t);
  }
  clearStorage() {
    sessionStorage.clear();
  }
};
const C = V, G = function(r, t) {
  let e = {};
  const n = T.getInstance();
  if (r)
    if (r.storageService)
      ({ storageService: e } = r), n.log("Storage Service already loaded, using existing version");
    else
      return r.storageService = e, t(e);
  return e;
}(
  typeof window == "object" && window || typeof globalThis == "object" && globalThis || void 0,
  function(r) {
    const t = {
      [c.PERMANENT]: { encryption: !0 },
      [c.TEMPORARY]: { encryption: !0 },
      [c.COOKIE]: {}
    }, e = {
      [c.PERMANENT]: new I({
        ...t[c.PERMANENT]
      }),
      [c.TEMPORARY]: new C({
        ...t[c.TEMPORARY]
      }),
      [c.COOKIE]: new E({
        ...t[c.COOKIE]
      })
    };
    return r.getStorage = (n = c.PERMANENT) => e[n], r.getLocalStorage = () => e[c.PERMANENT], r.getSessionStorage = () => e[c.TEMPORARY], r.getCookieStorage = () => e[c.COOKIE], r.setConfig = (n) => {
      for (const o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (o === c.PERMANENT && (e[o] = new I({
          ...n[o]
        })), o === c.TEMPORARY && (e[o] = new C({
          ...n[o]
        })), o === c.COOKIE && (e[o] = new E({
          ...n[o]
        })));
    }, r;
  }
), y = G, u = (r, t) => r || t || "", te = async ({
  registrationId: r,
  processType: t,
  accountType: e,
  feeSKU: n,
  kitSKU: o,
  lateFeeSKU: l,
  sessionData: d,
  profileData: p,
  redirectUrl: g
}) => {
  const i = [];
  n && i.push({
    entryId: 1,
    isPersistent: !0,
    isFreeItem: !1,
    product: {
      id: n
    },
    quantity: 1
  }), o && i.push({
    entryId: i.length + 1,
    isPersistent: t !== h.Registration,
    isFreeItem: !1,
    product: {
      id: o
    },
    quantity: 1
  }), l && i.push({
    entryId: i.length + 1,
    isPersistent: !0,
    isFreeItem: !1,
    product: {
      id: l
    },
    quantity: 1
  });
  const O = {
    id: r,
    type: t,
    businessNature: e,
    redirectUrl: g ?? N.ACCOUNT_INFORMATION
  }, A = W(O, i, d, p);
  return await M(A);
}, W = (r, t, e, n) => {
  var d, p;
  const o = w(`${Date.now()}`, w.URL), l = {
    firstName: u((d = e == null ? void 0 : e.act) == null ? void 0 : d.givenName),
    lastName: u((p = e == null ? void 0 : e.act) == null ? void 0 : p.familyName),
    accountType: u(e == null ? void 0 : e.type, r == null ? void 0 : r.businessNature),
    status: u(n == null ? void 0 : n.status),
    renewalFlag: u(e == null ? void 0 : e.renewalStatus),
    renewalLifeCycle: u(e == null ? void 0 : e.renewalLifecycle),
    amwayUserId: u(e == null ? void 0 : e.id),
    accountId: u(e == null ? void 0 : e.aboNum),
    ...(e == null ? void 0 : e.accountExpirationDate) && { expirationDate: new Date(e.accountExpirationDate) }
  };
  return {
    id: o,
    orderType: S.Regular,
    amwayUser: l,
    accountProcess: r,
    subCarts: [
      {
        subCartId: o,
        entries: t,
        amwayUser: {
          ...l,
          lastRenewedDate: new Date((n == null ? void 0 : n.lastRenewedDate) || Date.now()),
          entryDate: new Date((n == null ? void 0 : n.entryDate) || Date.now()),
          sponsor: e == null ? void 0 : e.uplineSponsorAccount
          // currently we do not have: uplinePlatinum, currentAwardLevel, highestAwardLevel, loaCode
          // ignore for now
        },
        totalEntries: t.length,
        totalAmPoint: 0,
        totalEarnedAmPoint: 0,
        totalAmPointDiscount: 0,
        isRationingApplied: !1,
        errors: [],
        proxySubCart: !1
      }
    ],
    totalEntries: t.length,
    version: 0,
    metaData: {
      createdAt: /* @__PURE__ */ new Date()
    }
  };
}, re = async (r, t, e, n, o = s.CART) => {
  var d, p;
  if (!e) {
    r(a(t));
    return;
  }
  const l = [];
  if (n && l.push({
    product: {
      id: n
    },
    quantity: 1
  }), e && l.push({
    product: {
      id: e
    },
    quantity: 1
  }), o === s.CART) {
    const g = {
      subCarts: [
        {
          subCartId: y.getLocalStorage().retrieve(m.CartId),
          entries: l
        }
      ],
      version: Number(y.getLocalStorage().retrieve(m.CartReqVersion))
    }, i = await P.addToCart({
      cartId: y.getLocalStorage().retrieve(m.CartId),
      subCartId: y.getLocalStorage().retrieve(m.CartId),
      payload: g,
      projections: $.DETAILED
    });
    r(a(i));
  } else
    (((p = (d = t == null ? void 0 : t.subCarts) == null ? void 0 : d.find((i) => (i == null ? void 0 : i.subCartId) === (t == null ? void 0 : t.id))) == null ? void 0 : p.entries) || []).push(...l), r(a(t));
};
export {
  re as a,
  te as c,
  y as l,
  u as r
};
//# sourceMappingURL=checkoutUtils-6aace743.mjs.map
